define('shared/util/adyen/storage',[],function () {
    function storeOrderId(orderId) {
        sessionStorage.setItem('orderId', orderId);
    }

    function retrieveOrderId() {
        var orderId = sessionStorage.getItem('orderId');
        if (!orderId) {
            throw('Failed to get order data from sessionStorage');
        }
        return orderId;

    }
    
    function deleteOrderId() {
        sessionStorage.removeItem('orderId');
    }

    return {
        storeOrderId: storeOrderId,
        retrieveOrderId: retrieveOrderId,
        deleteOrderId: deleteOrderId
    };
});

